import * as React from 'react';
import Select from 'react-select';
import {
    Button, Col, Input, Label, Nav, NavItem, NavLink,
    Row, TabContent, TabPane, Table,
    Toast, ToastBody, ToastHeader
} from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Period } from '../../redux/AfrSlice';
import { EnsureAfrsRequest, ensureAfrsForYear } from '../../redux/EntitiesSlice';
import { EditEntityQuery, Entity, loadEntity } from '../../redux/EntitySlice';
import { Reference, getPartValue } from '../../redux/TaxonomyReferenceSlice';
import { LogicalPeriodEnum, TaxonomyTypeEnum, TaxonomyVersionInfo, getAllTaxonomyVersions, selectAvailableVersions } from '../../redux/TaxonomyVersionSlice';
import Page from '../Page';
import GroupEmailer from '../feature/GroupEmailer';

export interface CreateReportOptions {
    reportName: string;
    taxonomyType: TaxonomyTypeEnum | null;
    logicalPeriods: LogicalPeriodEnum[];
}

const CreateReportsCore = (props : CreateReportOptions) => {
    const dispatch = useAppDispatch();
    const availableVersionsSelector: Array<TaxonomyVersionInfo> | null = useAppSelector(selectAvailableVersions);  
    //selectAvailableVersions

    const [afrYear, setAfrYear] = React.useState(0);
    const [logicalPeriod, setLogicalPeriod] = React.useState<LogicalPeriodEnum>(LogicalPeriodEnum.ANNUAL);
    const [disableButton, setDisableButton] = React.useState<boolean>(true);
    const [is939DataState, setIs939DataState] = React.useState<boolean>(true);
    const [dfsContactMap, setDfsContactMap] = React.useState<any>({});
    const [dfsContactSet, setDfsContactSet] = React.useState<Entity[]>([]);
    const [linkReferences, setLinkReferences] = React.useState<Reference[]>([]);

    const tt: TaxonomyTypeEnum | null = props.taxonomyType;

    const [activeTab, setActiveTab] = React.useState('1');
    const toggle = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab); 
    }

    var shortReportName: string = "AFR";

    switch (tt) {
        case TaxonomyTypeEnum.AFR:
            shortReportName = "AFR";
            break;

        default:
            shortReportName = "Report";
            break;
    }
    const getEmailTargetText = function (t: TaxonomyTypeEnum | null, year: number, period: LogicalPeriodEnum) : string {
        var update: string = "No Taxonomy Type";
        var yearText: string = (year <= 0 ? "No Year Selected" : year.toString());
        if (t) {
            switch (t) {
                case TaxonomyTypeEnum.AFR:
                    update = "AFR (" + yearText + ")";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    update = "Court Report 29.0085, F.S. (" + yearText + ")";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    var periodText = period === LogicalPeriodEnum.ANNUAL ? ((year >= 0) ? "And " : "") + "No Quarter Selected" : period.toString().replace("Q_", "Quarter ");
                    update = "Court Report 939.185, F.S. ( " + yearText + " " + periodText + " )";
                    break;

                default:
                    update = "The Selected Year";
                    break;

            }
        }
        return update;
    }
    const [emailTargetText, setEmailTargetText] = React.useState<string>(getEmailTargetText(props.taxonomyType, afrYear, logicalPeriod));
    const firstOption = {
        label: "Select fiscal Year", value: 0 };

    const contactSortKey = function (contact: any): string {
        var tstring: string = "z";
        if (contact.title && contact.title.length > 0 ) {
            tstring = contact.title;
        }
        return tstring + " " + contact.contact.lastName.toLowerCase();
    }

    const getReportTitleValue = function (): string {
        var result: string = "";

        if (tt != null) {

            switch (tt) {
                case TaxonomyTypeEnum.AFR:
                    result = "AFR";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    result = "Court Report 29.0085";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    result = "Court Report 939.185";
                    break;

                default:
                    result = "";
                    break;
            }
        }

        return result;
    }

    const getSortedContacts = function (entity: any): any[] {
        var result: any[] = [...entity.contacts];
        result.sort((a, b) => contactSortKey(a).localeCompare(contactSortKey(b)));
        return result;
    }
    const addContacts = function (entity: Entity, year : number) {
        if (!entity) {
            return;
        }
        var ecode: string = entity.code + "_" + year;
        if (dfsContactMap.hasOwnProperty(ecode)) {
            return;
        }
        dfsContactMap[ecode] = entity;
        if (ecode.indexOf("900003") >= 0) {
            setLinkReferences(entity.references);
        }
    }
    const loadDFSEntityContacts = function (year: number) {
        var eQuery: EditEntityQuery = {
            entityId: "900001",
            taxonomyYear: year
        };
        dispatch(loadEntity(eQuery)).then((result: any) => {
            var eQuery2 : EditEntityQuery = {
                entityId: "900002",
                taxonomyYear: year
            };
            addContacts(result.payload,year);
            dispatch(loadEntity(eQuery2)).then((result2: any) => {
                var eQuery3: EditEntityQuery = {
                    entityId: "900003",
                    taxonomyYear: year
                };
                addContacts(result2.payload,year);
                dispatch(loadEntity(eQuery3)).then((result3: any) => {
                    addContacts(result3.payload,year);
                });
            });
        });

    }
    const addFiscalYears = function (infoList: TaxonomyVersionInfo[], results: any[]) {
        infoList.map((i: TaxonomyVersionInfo) => {
            if (i.type === TaxonomyTypeEnum.AFR) {
                var yr = i.year;
                results.push({ value: yr, label: yr.toString() })
                loadDFSEntityContacts(yr);
            }
        })
    }
    const getAFRFiscalYears = function () {
        var years : any[] = [];
        dispatch(getAllTaxonomyVersions("AFR")).then((result: any) => {
            var infoList: TaxonomyVersionInfo[] = result.payload;
            addFiscalYears(infoList, years);
        });
        return years;
    }
    const getFiscalYears = function (ttNew: TaxonomyTypeEnum) {
        if (ttNew === TaxonomyTypeEnum.AFR) {
            return getAFRFiscalYears();
        }
        const d = new Date();
        let year = d.getFullYear();
        const maxYear = year + 1;
        var years = [{ value: 2019, label: "2019" }];
        loadDFSEntityContacts(2019);
        for (let i = 2020; i <= maxYear; i++) {
            years.push({ value: i, label: i.toString() });
            loadDFSEntityContacts(i);
        }
        years.unshift(firstOption);
        return years;
    }
    const [fiscalYearOptions, setFiscalYearOptions] = React.useState<Array<{ value: number, label: string }>>([]);

    const ddFiscalYear = (< div >
        <Select
            value={
                fiscalYearOptions.filter(function (option) {
                    return option.value === afrYear;
                })
            }
            onChange={handleYearChange}
            options={fiscalYearOptions}
        />
    </div >);

    function handleYearChange(event: any, action: any) {
        setAfrYear(event.value);
        setEmailTargetText(getEmailTargetText(tt, event.value, logicalPeriod));
        if (tt === TaxonomyTypeEnum.COURT_REPORTING_939 &&
            logicalPeriod === LogicalPeriodEnum.ANNUAL
        ) {
            setDisableButton(true);
        } else {
            setDisableButton(false);
        }


    }

    const handleQuarterSelection = function (event: any) {

        var selQuarter: LogicalPeriodEnum = event.target.value;
        if (selQuarter) {
            setLogicalPeriod(selQuarter);
            setEmailTargetText(getEmailTargetText(tt, afrYear, selQuarter));
            if (afrYear === 0) {
                setDisableButton(true);
            } else {
                setDisableButton(false);
            }
        }
    }


    const handleEnsure = function () {

        var textResponse = 'The new ' + props.reportName + ' records have been created.';
        if (afrYear > 0) {

            Swal.fire({
                title: 'Are you sure you want to create new ' + props.reportName + ' records for ' + afrYear + '?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    var req: EnsureAfrsRequest = {
                        fiscalYear: afrYear,
                        taxonomyType: tt,
                        logicalPeriod: logicalPeriod
                    }
                    dispatch(ensureAfrsForYear(req)).then((result: any) => {
                        Swal.fire(
                            'Created!',
                            textResponse,
                            'success'
                        )
                        if (props.taxonomyType == TaxonomyTypeEnum.COURT_REPORTING_939) {
                            setIs939DataState(true);
                        }
                    });
                }
            });
        }
    }

    const doesPeriodStartDateExist = function (dateValue: string): boolean {

        let result: boolean = false;

        if (availableVersionsSelector != null) {
            if (availableVersionsSelector[0].periods != null) {

                var foundValue = availableVersionsSelector[0].periods.find((element: Period) =>

                    element.startDate != null &&
                    element.startDate.indexOf(dateValue) > -1
                )
                if (foundValue) {
                    result = true;
                }
            }
        }

        return result;

    }

    const shouldEnableQuarterCreation = function (option: LogicalPeriodEnum): boolean | undefined {
        let result: boolean = false;

        if (availableVersionsSelector != null && availableVersionsSelector.length > 0) {
            if (availableVersionsSelector[0].periods != null) {
                if (afrYear > 0) {
                    switch (option) {

                        case LogicalPeriodEnum.Q_1:

                            let priorQuarterFourDate: string = (afrYear - 1).toString() + "-07-01";

                            if (doesPeriodStartDateExist(priorQuarterFourDate)) {
                                result = true;
                            }

                            break;

                        case LogicalPeriodEnum.Q_2:

                            let priorQuarterOneDate: string = (afrYear - 1).toString() + "-10-01";

                            if (doesPeriodStartDateExist(priorQuarterOneDate)) {
                                result = true;
                            }

                            break;

                        case LogicalPeriodEnum.Q_3:

                            let priorQuarterTwoDate: string = (afrYear).toString() + "-01-01";

                            if (doesPeriodStartDateExist(priorQuarterTwoDate)) {
                                result = true;
                            }

                            break;

                        case LogicalPeriodEnum.Q_4:

                            let priorQuarterThreeDate: string = (afrYear).toString() + "-04-01";

                            if (doesPeriodStartDateExist(priorQuarterThreeDate)) {
                                result = true;
                            }

                            break;

                        default:
                            break;
                    }
                }              
            }
        }

        return result;
    }
    const getLinkReferencesForTypeAndYear = function (refs: Reference[], tt : TaxonomyTypeEnum | null, ttYear: number): Reference[] {
        var tmatch = ttYear.toString();
        if (tt) {
            switch (tt) {
                case TaxonomyTypeEnum.AFR:
                    tmatch = ttYear.toString();
                    break;
                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    tmatch = tt.toString();
                    break;
                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    tmatch = tt.toString();
                    break;
            }
        }
        var result: Reference[] | undefined = refs.filter(r => getPartValue(r, "TaxonomyVersion") === tmatch);
        if (result === undefined) {
            return [];
        }
        return result;
    }

    React.useEffect(() => {
        if (props.taxonomyType == TaxonomyTypeEnum.COURT_REPORTING_939 && is939DataState == true) {
            
            dispatch(getAllTaxonomyVersions(props.taxonomyType));
            setIs939DataState(false);
        }
    }, [is939DataState])


    React.useEffect(() => {
        if (tt === TaxonomyTypeEnum.COURT_REPORTING_29) {
            var elist: Entity[] = [];
            ["900001_", "900002_", "900003_"].map((option, idx) => {
                var ekey = option + afrYear;
                if (dfsContactMap.hasOwnProperty(ekey)) {
                    elist.push(dfsContactMap[ekey]);
                }
            });
            setDfsContactSet(elist);
        }
    }, [afrYear])

    React.useEffect(() => {
        if (props.taxonomyType) {
            setFiscalYearOptions(getFiscalYears(props.taxonomyType));
        } else {
            setFiscalYearOptions([]);
        }
    }, [props])





    /*******************************************************************************/
    return (
        <Page>

            <Nav tabs>
                <NavItem>
                    <NavLink
                        active={activeTab === '1'}
                        onClick={() => { toggle('1'); }}>
                        Create {getReportTitleValue()} For Selected Year
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={activeTab === '2'}
                        onClick={() => { toggle('2'); }}>
                        {getReportTitleValue()} Emails
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col>
                            <Row>
                                <Col >
                                    <h4>Create {props.reportName} For Selected Year {props.taxonomyType === TaxonomyTypeEnum.COURT_REPORTING_939 ? " And Quarter" : ""}:</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table borderless >
                                        <tbody>

                                            <tr>
                                                <th className="col-2 text-right">Fiscal Year:</th>
                                                <td className="col-4">{ddFiscalYear}</td>
                                                <td className="col-4"><Button type="button" onClick={handleEnsure} disabled={disableButton}>Create {shortReportName}s</Button></td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    {tt === TaxonomyTypeEnum.COURT_REPORTING_939
                                                        ?
                                                        <Toast className="auditDetail">
                                                            <ToastHeader className="auditDetail">Choose Quarter</ToastHeader>
                                                            <ToastBody>
                                                                <div>
                                                                    <Table borderless >
                                                                        <tbody>
                                                                            <tr>
                                                                                {props.logicalPeriods.map((option, idx) => (
                                                                                    <td key={option.toString()}>
                                                                                        <Label className="ml-4" >
                                                                                            <Input type="radio"
                                                                                                name={option.toString()}
                                                                                                value={option}
                                                                                                disabled={!shouldEnableQuarterCreation(option)}
                                                                                                onChange={handleQuarterSelection}
                                                                                                checked={(logicalPeriod === option) ? true : false}
                                                                                            />{option.toString().replace("Q_", "Quarter ")}
                                                                                        </Label>
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            </ToastBody>

                                                        </Toast>
                                                        : <div></div>
                                                    }
                                                </td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    {tt === TaxonomyTypeEnum.COURT_REPORTING_29
                                                        ?
                                                        <Toast className="auditDetail">
                                                            <ToastHeader className="auditDetail">DFS Officers</ToastHeader>
                                                            <ToastBody>
                                                                <div>
                                                                    {dfsContactSet.map((ent, idx) => (
                                                                        <div>
                                                                            <h5>{ent.name}</h5>
                                                                            <Table>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Title</th>
                                                                                        <th>First</th>
                                                                                        <th>Last</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {getSortedContacts(ent).map((con, idx) =>
                                                                                    (
                                                                                        <tr>
                                                                                            <td>{con.title}</td>
                                                                                            <td>{con.contact.firstName}</td>
                                                                                            <td>{con.contact.lastName}</td>

                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                            <hr></hr>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </ToastBody>

                                                        </Toast>
                                                        : <div></div>
                                                    }
                                                </td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>               
                        </Col>                      
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row className="w-100">
                        <Col>
                            <GroupEmailer
                                afrYear={afrYear}
                                period={logicalPeriod}
                                emailTypeValue={tt ? tt : TaxonomyTypeEnum.BASE}
                                references={getLinkReferencesForTypeAndYear(linkReferences, tt, afrYear)}
                                emailTarget={emailTargetText}
                            />
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>

            
        </Page>
    );
}
export default CreateReportsCore;


